import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import firebase from 'firebase/app';
import 'firebase/auth';
import { AuthFormPage } from './auth-form/auth-form.page';
import { Plan } from './classes/plan';
import { User } from './classes/user';
import { AuthStore } from './store/auth.store';
import { PlanStore } from './store/plan.store';
import * as moment from 'moment';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private planStore: PlanStore,
    private authStore: AuthStore,
    private storage: Storage,
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private router: Router,
  ) {

    this.storage.create();
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        localStorage.setItem('uid', user.uid);
        await this.authStore.initUser(user.uid);
        await this.planStore.initPlans();
        this.authStore.user.subscribe(val => { this.user = val });
        this.planStore.plans.subscribe(val => {
          this.plans = val;
          if (this.plans) {
            this.plans.sort((a, b) => a.startTime - b.startTime)
          }
        })
      } else {
        localStorage.removeItem('uid');
        this.storage.remove('plans');
        if (!this.authStore.user.isStopped) {
          this.authStore.user.next(null);
          this.planStore.plans.next(null);
        }
        this.user = null;
        this.plans = null;
      }
    })
  }

  user: User;
  plans: Plan[]
  showPlans = true;
  menuOpen = true;
  showMonths = [];
  showMenu = true;

  showAuth(view) {
    this.modalCtrl.create(
      {
        component: AuthFormPage,
        componentProps: { authView: view }
      }).then(p => p.present())
  }

  nav(plan) {
    this.planStore.currentPlan.next(plan)
    this.navCtrl.navigateRoot('/home/' + plan.id);
  }


  newPlan() {
    this.planStore.currentPlan.next({} as any)
    this.navCtrl.navigateRoot('/')
  }

  isActive(plan: Plan) {
    return this.router.isActive(`/home/${plan.id}`, false)
  }


  showDate(plan, plans, index) {
    if (index == 0) {
      return true
    }

    let lastIndex = index - 1;
    let lastPlan = plans[lastIndex];
    let lastPlanMonth = moment(lastPlan.startTime, 'x').format('MMM');
    let month = moment(plan.startTime, 'x').format('MMM');
    if (lastPlanMonth == month) {
      return false
    } else {
      return true
    }
  }

  toggleShowMonth(plan) {
    let showMonth = moment(plan.startTime, 'x').format('MMMYYYY');
    if (this.isInShowMonths(plan)) {
      this.removeShowMonths(showMonth)
    } else {
      this.addShowMonths(showMonth)
    }
  }
  addShowMonths(monthyear) {
    this.showMonths.push(monthyear)
  }

  removeShowMonths(monthyear) {
    let index = this.showMonths.findIndex(my => my == monthyear)
    this.showMonths.splice(index, 1)
  }

  isInShowMonths(plan) {
    let showMonth = moment(plan.startTime, 'x').format('MMMYYYY');
    let index = this.showMonths.findIndex(my => my == showMonth);
    if (index > -1) {
      return true
    } else {
      return false
    }
  }
}

